import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'
import auth from './modules/auth'
import Cookies from "js-cookie";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth
  },
  plugins: [
    createPersistedState({

    reducer: state => (
    {
      auth: state.auth,
      serviceName: state.serviceName,
      payPriceMerchantId: state.payPriceMerchantId,
      trialPopUpDate: state.trialPopUpDate,
      serviceGuideList: state.serviceGuideList,
      previousPath: state.previousPath
    }),
    storage: {
      getItem: (key) => {
        return Cookies.get(key)
      },
      setItem: (key, value) => {
        if(location.protocol === 'http:') {
          Cookies.set(key, value);
        } else {
          Cookies.set(key, value, { expires: 3, secure: true })
        }
      },
      removeItem: (key) => {
        Cookies.remove(key)
      },
    } })
  ],
  state: {
    serviceName: '',
    device: 'pc',

    brand: {},

    menus: [],
    searchResult: undefined,
    sidebar: true,
    // 모달 상태값
    modalStatus: 'close',
    // 모달 값
    modalItem: {},
    modalResponse: {},
    // 로딩 상태값
    loadingStatus:true,
    backendData: {},
    // 패키지
    packages:[],
    // 내부 플러그인
    internalPlugin: {},
    // 마스터 DB에 있는 서비스 정보
    masterService: {
      version_service: 1,
      service_type: 2,
    },
    // 서비스 세팅 상품
    serviceSettingProduct: {},
    // 서비스 세팅
    serviceSetting: {},
    // 판넬 설정 리스트
    panelSetting: [],
    // 구입할 상품
    purchase_product:[],
    // 종일 패키지 사용 여부
    dailyEnable: false,
    // 상품 일정 시간대
    scheduleTimes: [],
    // 서비스 설정 pg 구매시 merchant_id
    payPriceMerchantId: '',
    trialPopUpDate: '',
    fromBuilder: false,
    openAppMarket: false,
    // 서비스 운영 가이드
    serviceGuideList: [],
    guide: undefined,
    orderSetting: undefined,
    masterServiceInfo: undefined,
    dashboardPanel: {
      visible: {
        packages: true,
        guide: true
      }
    },
    prodTab: 0,
    prodPackage: '',
    routeHash: '',
    previousPath: '',              // 로그인 후 돌아갈 페이지
  },

  actions: {

  },
  mutations: {
    setMasterService(state, value) {
      state.masterService = value;
    },
    setInternalPlugin (state, value) {
      state.internalPlugin = value;
    },
    setServiceSettingProduct (state, value) {
      state.serviceSettingProduct = value;
    },
    setServiceSetting (state, value) {
      state.serviceSetting = value;
    },
    setPurchaseProduct (state, value) {
      state.purchase_product = value;
    },
    removePurchaseProduct (state, value) {
      state.purchase_product = [];
    },
    setSideBar (state, value) {
      state.sidebar = value;
    },
    setServiceName (state, value) {
      state.serviceName = value;
    },
    setDevice(state, value) {
      state.device = value;
    },
    setBrand (state, value) {
      state.brand = value;
    },
    setPanel (state, value) {
      state.panelSetting = value;
    },
    setMenus (state, value) {
      state.menus = value;
    },
    // 모달 닫을때 실행
    cancelModal (state) {
      state.modalStatus = 'cancel';
      state.modalItem = {};
      $('body').css('overflow', 'unset');
    },
    closeModal (state, value) {
      state.modalStatus = 'close';
      if(value) {
        state.modalResponse = value;
        state.modalResponse.modal_type = state.modalItem.type;
      }
      state.modalItem = {};
      $('body').css('overflow', 'unset');
    },
    // 모달 오픈시 실행
    openModal (state, value) {
      state.modalItem = value;
      state.modalStatus = 'open';
      $('body').css('overflow', 'hidden');
    },
    setBackendData(state, value) {
      let key = Object.keys(value)[0];
      state.backendData[key] = value[key];
    },
    setLoading(state, value) {
      state.loadingStatus = value;
    },
    setPackages(state, value) {
      state.packages = value;
    },
    setDailyEnable(state, value) {
      state.dailyEnable = value;
    },
    setScheduleTimes(state, value) {
      state.scheduleTimes = value;
    },
    setPayPriceMerchantId(state, value) {
      state.payPriceMerchantId = value;
    },
    setTrialPopUpDate(state, value) {
      state.trialPopUpDate = value;
    },
    setFromBuilder(state) {
      state.fromBuilder = true;
    },
    setOpenAppMarket(state, value) {
      console.log('setOpenAppMarket', value)
      state.openAppMarket = value;
    },
    setServiceGuideList(state, value) {
      state.serviceGuideList = value;
    },
    setGuide(state, value) {
      state.guide = value;
    },
    setOrderSetting(state, value) {
      state.orderSetting = value;
    },
    setMasterServiceInfo(state, value) {
      state.masterServiceInfo = value;
    },
    setDashboardPanel(state, value) {
      state.dashboardPanel = value;
    },
    setProdTab(state, value) {
      state.prodTab = value;
    },
    setProdPackage(state, value) {
      state.prodPackage = value
    },
    setRouteHash(state, value) {
      state.routeHash = value;
    },
    setSearchResult(state, value) {
      state.searchResult = value;
    },
    setPreviousPath(state, value) {
      if(value.indexOf('login')=== -1) {
        state.previousPath = value;
      }
    }
  },
  getters: {
    masterServiceInfo: state => state.masterServiceInfo,
    masterService: state => state.masterService,
    serviceVersion: state => state.masterService.version_service,
    serviceType: state => state.masterService.service_type,
    serviceName: state => state.serviceName,
    device: state => state.device,
    favicon: state => state.brand.favicon,
    brand: state => state.brand,
    menus: state => state.menus,
    sidebar: state => state.sidebar,
    modalItem: state => state.modalItem,
    modalResponse: state => state.modalResponse,
    backendData: state => state.backendData,
    loading: state => state.loadingStatus,
    getPurchaseProduct: state=> state.purchase_product,
    getPackages: state => state.packages,
    getInternalPlugin: state => state.internalPlugin,
    getPanelSetting: state => state.panelSetting,
    getServiceSettingProduct: state => state.serviceSettingProduct,
    getServiceSetting: state => state.serviceSetting,
    dailyEnable: state => state.dailyEnable,
    scheduleTimes: state => state.scheduleTimes,
    payPriceMerchantId: state => state.payPriceMerchantId,
    trialPopUpDate: state => state.trialPopUpDate,
    fromBuilder: state => state.fromBuilder,
    openAppMarket: state => state.openAppMarket,
    serviceGuideList: state => state.serviceGuideList,
    guide: state => state.guide,
    orderSetting: state => state.orderSetting,
    dashboardPanel: state => state.dashboardPanel,
    prodTab: state => state.prodTab,
    prodPackage: state => state.prodPackage,
    routeHash: state => state.routeHash,
    searchResult: state => state.searchResult,
    previousPath: state => {
      let path = state.previousPath;
      state.previousPath = '';
      return path;
    },
  }
})
